import React, { useEffect, useState } from 'react';
import styles from './StoreItem.module.scss';

import IconItemQty from '../../../assets/icons/store/icon_item_qty_logo.png';
import IconTower from '../../../assets/icons/logo-tower-circle-border.svg';
import IconCoolDown from '../../../assets/icons/store/icon_cooldown.png';
import IconCoolDownWhite from '../../../assets/icons/store/icon_cooldown_white.png';
import IconSold from '../../../assets/icons/store/icon_sold.png';
import IconPackage from '../../../assets/icons/store/icon_package.svg';
import moment from 'moment';
import { countdownTimer } from '../../../services/TimerService';

const StoreItem = ({
    name,
    category,
    salesCategory,
    salesLimit,
    isBuyable,
    buyablePeriodTimeout,
    image,
    description,
    price,
    vipPoints,
    stat1,
    stat2,
    discountPercent,
    specialDiscountPercent,
    originalPrice,
    itemId,
    itemPeriodFrom,
    itemPeriodTo,
    itemStockCount,
    submitAction,
}) => {
    const [loading, setLoading] = useState(false);
    const [countdownTime, setCountdownTime] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
    const [CountdownStartTime, setCountdownStartTime] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });

    let currentTimestamp = moment().utc();
    let utcBuyablePeriodTimeout = buyablePeriodTimeout ? moment.unix(buyablePeriodTimeout) : '';
    let timedItemStartTime = itemPeriodFrom ? moment.utc(itemPeriodFrom) : '';
    let timedItemEndTime = itemPeriodTo ? moment.utc(itemPeriodTo) : '';

    const handleBuyClick = async () => {
        setLoading(true);
        await submitAction(itemId, name, price);
        setLoading(false);
    }

    const padAddtionalZero = (num) => {
        return num < 10 ? '0' + num : num;
    }

    useEffect(() => {
        if (buyablePeriodTimeout) {
            countdownTimer(utcBuyablePeriodTimeout, setCountdownTime, currentTimestamp);
        } else if (itemPeriodFrom && itemPeriodTo) {
            let itemBuyableStartTime = moment.utc(itemPeriodFrom);
            let currentTimestamp1 = moment().utc();
            countdownTimer(itemBuyableStartTime, setCountdownStartTime, currentTimestamp1);
            let currentTimestamp2 = moment().utc();
            let itemBuyableEndTime = moment.utc(itemPeriodTo);
            countdownTimer(itemBuyableEndTime, setCountdownTime, currentTimestamp2);
        }
    }, [buyablePeriodTimeout, itemPeriodTo])

    // Todo: Name improvements.
    let cannotBuyDailyGems = (salesCategory === 'periodic') && (currentTimestamp < utcBuyablePeriodTimeout);
    let cannotBuyStarterPacks = (salesCategory === 'limited') && (!isBuyable);
    let cannotBuyTimedItems = (salesCategory === 'timed') && (itemStockCount <= 0 || !isBuyable);
    let timedItemsPeriodNotStarted = (salesCategory === 'timed') && currentTimestamp < timedItemStartTime;
    let timedItemsPeriodOver = (salesCategory === 'timed') && currentTimestamp > timedItemEndTime;

    return (
        <div className={`${styles.store_item}`}>
            {/* Cooldown timer should only be displayed when daily gems are in cooldown */}
            { (cannotBuyDailyGems || timedItemsPeriodNotStarted)
                ?
                    <div className={styles.cooldown_region}>
                        <div className={styles.cooldown_content}>
                            <img src={IconCoolDown} className={styles.cooldown_image} alt="cooldown" />
                            {timedItemsPeriodNotStarted ?
                                <div className={styles.cooldown_timer}>{`${padAddtionalZero(CountdownStartTime.days)}:${padAddtionalZero(CountdownStartTime.hours)}:${padAddtionalZero(CountdownStartTime.minutes)}:${padAddtionalZero(CountdownStartTime.seconds)}`}</div> :
                                <div className={styles.cooldown_timer}>{`${padAddtionalZero(countdownTime.days)}:${padAddtionalZero(countdownTime.hours)}:${padAddtionalZero(countdownTime.minutes)}:${padAddtionalZero(countdownTime.seconds)}`}</div>
                            }
                        </div>
                    </div>
                :
                    (cannotBuyStarterPacks || cannotBuyTimedItems)
                    ?
                        <div className={styles.cooldown_region}>
                            <div className={styles.cooldown_content}>
                                <img src={IconSold} className={styles.sold_image} alt="sold" />
                            </div>
                        </div>
                    : timedItemsPeriodOver ?
                        <div className={styles.cooldown_region}>
                            <div className={styles.cooldown_content}>
                                <img src={IconSold} className={styles.sold_image} alt="sold" />
                            </div>
                        </div>  
                        : <></>
            }

            <div className={`${styles.details} ${(cannotBuyDailyGems || cannotBuyStarterPacks || cannotBuyTimedItems) ? styles.reduced_opacity : '' }`}>
                {(description !== undefined) ?
                    <div className={styles.store_item_hovered_content}>
                        <div className={styles.store_item_description}>
                            {description.split("\n").map((item, idx) => {
                                return (
                                    <span key={idx}>
                                        {item}
                                        <br/>
                                    </span>
                                )
                            })}
                        </div>
                    </div>
                    : <></>
                }

                {salesCategory === 'timed' ? (
                    timedItemsPeriodOver ? (
                        <div className={styles.store_item_timed_offer_end_date}>
                            <img src={IconCoolDownWhite} alt="hourglass" />
                            <span>0d 0h 0m</span>
                        </div>
                        ): (
                            <div className={styles.store_item_timed_offer_end_date}>
                                <img src={IconCoolDownWhite} alt="hourglass" />
                                <span>{countdownTime.days}d {countdownTime.hours}h {countdownTime.minutes}m</span>
                            </div>
                    )) :
                    <></>
                }

                <div className={styles.store_item_name}>
                    <span>{name}</span>

                    {((discountPercent > 0) || (specialDiscountPercent > 0))
                        ? <div className={styles.store_item_promo_rate}>
                            {`-${(specialDiscountPercent > discountPercent) ? specialDiscountPercent : discountPercent}%`}
                            </div>
                        : <></>
                    }
                </div>
                {salesLimit > 1 &&
                    <div className={styles.item_stock_number}>
                        <img src={IconPackage} alt="package" />
                        <span>Stock: {timedItemsPeriodOver ? 0 : itemStockCount}</span>
                    </div>
                }
                <div className={styles.store_item_image}>
                    <img src={image} alt="item" />
                </div>
                <div className={styles.store_item_packed_qty}>

                    {/* For first type of item qty */}
                    {stat1
                        ? <div className={styles.store_item_qty_type}>
                            <div className={styles.store_item_qty_logo}>
                                <img src={IconItemQty} alt="quantity" />
                            </div>
                            <div className={styles.store_item_qty_units}>
                                {`x${stat1}`}
                            </div>
                        </div>
                        : ''
                    }

                    {/* Commenting out the second type of stats for the time-being */}
                    {/* For second type of item qty */}
                    {/* <div className={styles.store_item_qty_type}>
                        <div className={styles.store_item_qty_logo}>
                            <img src={IconItemQty} alt="quantity" />
                        </div>
                        <div className={styles.store_item_qty_units}>
                            {`x${stat2}`}
                        </div>
                    </div> */}
                </div>
            </div>

            <div className={`${styles.purchase_btn} ${(cannotBuyDailyGems || cannotBuyStarterPacks || cannotBuyTimedItems) ? styles.reduced_opacity : '' }`}>
                <button className={styles.store_item_price_btn} disabled={loading} onClick={handleBuyClick}>
                    {!loading ?
                        <>
                            {(((discountPercent > 0) || (specialDiscountPercent > 0)) && (originalPrice !== price))
                                ?
                                <div className={styles.store_item_price_before}>
                                    <div className={styles.store_item_price_before_slashed}>
                                        <div className={styles.slash}></div>
                                    </div>

                                    <div className={styles.store_item_price_before_content}>
                                        <div className={styles.store_item_price_before_logo}>
                                            <img src={IconTower} width="19px" height="19px" alt="tower" />
                                        </div>
                                        <div className={styles.store_item_price_before_amount}>
                                            {parseInt(originalPrice).toLocaleString()}
                                        </div>
                                    </div>
                                </div>
                                :
                                <></>
                            }
                            <div className={styles.store_item_price_after}>
                                <div className={styles.store_item_price_after_logo}>
                                    <img src={IconTower} width="25px" height="25px" alt="tower" />
                                </div>
                                <div className={styles.store_item_price_after_amount}>
                                    {parseInt(price).toLocaleString()}
                                </div>
                            </div>
                        </> :
                        <div className={styles.loading_text}>Processing...</div>
                    }
                </button>
            </div>
        </div>
    )
}

export { StoreItem };
